import { ajaxPrefilter } from 'jquery';
import {post,get} from '../../../libs/ajax.js';

export default {
    // 获取页面权限
    getPageAllowAction: (data,options) => {
        options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/get_page_allow_action', data, options)
    },

    /* 列表相关接口 */

    // 获取时区
    getTimeZone:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_time_zone', data, options);
    },
    // 设置时区
    setTimeZone(data,options){
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/set_time_zone',data,options);
    },
    // 获取自定义筛选条件
    getCustomFilter:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_custom_filter', data, options);
    },
    // 设置自定义筛选条件
    editCustomFilter:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/edit_custom_filter', data, options);
    },



    /* 【广告系列组】-Tab */
    // 【广告系列组】 - 筛选条件获取下拉框
    getOrgSearchList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/get_org_search_list', data, options);
    },
    //
    getCampaignSearchList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/get_campaign_search_list', data, options);
    },
    getAdGroupSearchList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/get_adgroup_search_list', data, options);
    },
    getKeywordSearchList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/get_keyword_search_list', data, options);
    },
    getSearchTermSearchList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/get_search_term_search_list', data, options);
    },
    getNegativeKeywordSearchList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/get_negative_keyword_search_list', data, options);
    },

    // 获取【广告系列组】列表
    getOrgList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/get_org_list', data, options);
    },
    // 导出【广告系列组】列表
    exportOrgList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/export_org_list', data, options);
    },


    // 获取自定义筛选条件
    getCustomField:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_custom_field', data, options);
    },
    // 获取自定义筛选条件
    setCustomField:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/edit_custom_field', data, options);
    },

    /* 【广告系列】-Tab */
    // 获取【广告系列】列表
    getCampaignList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/get_campaign_list', data, options);
    },
    // 导出【广告系列】列表
    exportCampaignList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/export_campaign_list', data, options);
    },
    // 修改【广告系列】开关
    editCampaignStatus:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/edit_campaign_status', data, options);
    },
    // 修改【广告系列】日预算
    editCampaignDailyBudget:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/edit_campaign_daily_budget', data, options);
    },
    // 修改【广告系列】名称
    editCampaignName:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/edit_campaign_name', data, options);
    },
    // 删除【广告系列】
    delCampaign:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/del_campaign', data, options);
    },
    // 获取【广告系列】信息
    getCampaignInfo:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_campaign_info', data, options);
    },
    // 编辑【广告系列】
    editCampaign:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/edit_campaign', data, options);
    },


    /* 【广告组】-Tab */
    // 获取【广告组】列表
    getAdgroupList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/get_adgroup_list', data, options);
    },
    // 导出【广告组】列表
    exportAdgroupList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/export_adgroup_list', data, options);
    },
     // 修改【广告组】开关
    editAdgroupStatus:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/edit_adgroup_status', data, options);
    },
    // 修改【广告组】默认最高每次点击付费出价
    editAdgroupDailyAmount:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/edit_adgroup_default_bid_amount', data, options);
    },
    // 修改【广告组】修改每次转化费用上限
    editAdgroupGoal:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/edit_adgroup_cpa_goal', data, options);
    },
    // 修改【广告组】名称
    editAdgroupName:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/edit_adgroup_name', data, options);
    },
    // 删除【广告组】
    delAdgroup:(data,options) => {
        options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/del_adgroup', data, options);
    },



    /* 【关键词】-Tab */

    //  获取【关键词】列表
    getKeywordList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/get_keyword_list', data, options);
    },
    // 导出【关键词】列表
    exportKeywordList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/export_keyword_list', data, options);
    },
    // 修改【关键词】修改最高每次点击付费出价
    editKeywordBidAmount:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/edit_targeting_keyword_bid_amount', data, options);
    },
     // 修改关键词开关
     edittargeting:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/edit_targeting_keyword_status', data, options);
    },
    // 检查是否可以批量操作最高每次点击付费出价
    checkKeywordBidAmount:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/check_targeting_keyword_bid_amount_currency', data, options);
    },
    // 修改最高每次点击付费出价
    checkSignKeywordBidAmount:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/edit_targeting_keyword_bid_amount', data, options);
    },
    // 关键词-添加关键词
    keywordAddKeyword:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/add_keyword', data, options);
    },
    // 关键词-复制
    keywordCopyKeyword:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/copy_keyword', data, options);
    },
    // 关键词-添加为否定关键词
    keywordAddAsNegativeKeyword:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/keyword/add_as_negative_keyword', data, options);
    },
    // 关键词- 通过列表筛选参数获取全部关键词
    getAllKeywords:(data,options) => {
        options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/get_keywords', data, options);
    },


    /* 【搜索词】-Tab */
    //  获取【搜索词】列表
    getSearchTermList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/get_search_term_list', data, options);
    },
    // 导出【搜索词】列表
    exportSearchTermList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/export_search_term_list', data, options);
    },
    // 搜索词-添加为关键词
    searchTermAddAsKeyword:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/add_as_keyword', data, options);
    },
    // 搜索词-添加为否定关键词
    searchTermAddAsNegativeKeyword:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/search_term/add_as_negative_keyword', data, options);
    },
   


    /* 【否定关键词词】-Tab */
    //  获取【关键词】列表
    getNegativeKeywordList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/get_negative_keyword_list', data, options);
    },
    // 导出【关键词】列表
    exportNegativeKeywordList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/export_negative_keyword_list', data, options);
    },
    // 删除否定关键词
    delNegativeKeyword:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/del_negative_keyword', data, options);
    },
    // 否定关键词-添加否定关键词
    negativeKeywordAddNegativeKeyword:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/add_negative_keyword', data, options);
    },
    // 否定关键词-复制
    negativeKeywordCopyNegativeKeyword:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/copy_negative_keyword', data, options);
    },



    // 获取所属广告系列组搜索框
    getOrgSelectorList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_org_selector', data, options);
    },
    // 获取所属广告系列搜索框
    getCampaignSelectorList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_campaign_selector', data, options);
    },
    // 获取所属广告组搜索框
    getAdGroupSelectorList:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_adgroup_selector', data, options);
    },
    // 校验否定关键词是否可以复制
    checkNegativeKeywordCopy:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/check_negative_keyword_copy_negative_keyword', data, options);
    },
    // 校验关键词数据（添加关键词、否定关键词时，点击添加后调用）
    checkAddKeywords:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/check_keywords', data, options);
    },
    // 校验关键词是否可以添加关键词
    checkKeywordAddKeyword:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/check_keyword_add_keyword', data, options);
    },
    // 校验关键词是否可以复制
    checkKeywordCopyKeyword:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/check_keyword_copy_keyword', data, options);
    },
    // 校验关键词是否可以添加为否定关键词
    checkKeywordAddAsNegativeKeyword:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/check_keyword_add_as_negative_keyword', data, options);
    },
    // 校验搜索词是否可以添加为关键词
    checkSearchTermAddAsKeyword:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/check_search_term_add_as_keyword', data, options);
    },
    // 校验搜索词是否可以添加为否定关键词
    checkSearchTermAddAsNegativeKeyword:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/check_search_term_add_as_negative_keyword', data, options);
    },
    // 校验否定关键词是否可以添加否定关键词
    checkNegativeKeywordAddNegativeKeyword:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/check_negative_keyword_add_negative_keyword', data, options);
    },
    // 校验否定关键词是否可以复制
    checkNegativeKeywordCopyNegativeKeyword:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/check_negative_keyword_copy_negative_keyword', data, options);
    },



    /* 【创建与编辑相关】 */

    //  获取所属广告系列组搜索框
    getPromotionOrgOptions:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_org_selector', data, options);
    },

    //  获取所属广告系列搜索框
    getPromotionCampaignOptions:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_campaign_selector', data, options);
    },

    //  校验广告系列名称是否合法
    getPromotionCampaignName:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/check_campaign_name', data, options);
    },

    //  校验广告组名称是否合法
    getPromotionAdgroupName:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/check_adgroup_name', data, options);
    },

    //  国家下拉搜索框
    getPromotionCountryOptions:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_country_selector', data, options);
    },

    //  省/自治区/直辖市下拉搜索框
    getPromotionAreaOptions:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_admin_area_selector', data, options);
    },

    //  城市下拉搜索框
    getPromotionLocalityOptions:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_locality_selector', data, options);
    },

    //  获取推广的App搜索框
    getPromotionAppOptions:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_app_selector', data, options);
    },

    //  获取推广的App投放配置
    getPromotionAppEligibility:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_app_eligibility', data, options);
    },

    // 获取广告系列每日预算配置
    getCampaignDailyBudgetConfig:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_campaign_daily_budget_config', data, options);
    },
    // 获取广告系列信息
    get_create_campaign_info:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_campaign_info', data, options);
    },
    // 获取推广的App投放配置
    get_create_app_eligibility:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_app_eligibility', data, options);
    },
    // 获取广告组付费出价配置
    get_create_app_am_config:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_adgroup_default_bid_amount_config', data, options);
    },
    // 获取广告系列配置
    getOrgConfig:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_config', data, options);
    },
    // 创建广告系列组 1
    org_add_ad:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/org_add_ad', data, options);
    },
    // 创建广告系列组 2
    campaign_add_ad:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/campaign_add_ad', data, options);
    },
    // 创建广告系列组 3
    campaign_add_campaign:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/campaign_add_campaign', data, options);
    },
    // 创建广告系列组 4
    adgroup_add_ad:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/adgroup_add_ad', data, options);
    },
    // 创建广告系列组 5
    adgroup_add_adgroup:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/adgroup_add_adgroup', data, options);
    },
    // 创建广告系列组 6
    keyword_add_ad:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/keyword_add_ad', data, options);
    },
    // 创建广告系列组 7
    search_term_add_ad:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/search_term_add_ad', data, options);
    },
    // 创建广告系列组 8
    negative_keyword_add_ad:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/negative_keyword_add_ad', data, options);
    },
    // 获取广告组 详情
    get_create_adgroup_info:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_adgroup_info', data, options);
    },
    // 编辑广告系列组 
    adgroup_edit_adgroup:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/edit_adgroup', data, options);
    },

    // 转换对应时区的日期时间
    get_time_zone_datetime:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_time_zone_datetime', data, options);
    },


    /* 校验权限 */

    // 校验广告系列组是否可以新建广告
    check_org_add_ad:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/check_org_add_ad', data, options);
    },
    // 校验广告系列是否可以新建广告
    check_campaign_add_ad:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/check_campaign_add_ad', data, options);
    },
    // 校验广告组是否可以新建广告
    check_adgroup_add_ad:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/check_adgroup_add_ad', data, options);
    },
    // 校验关键词是否可以新建广告
    check_keyword_add_ad:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/check_keyword_add_ad', data, options);
    },
    // 校验搜索词是否可以新建广告
    check_search_term_add_ad:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/check_search_term_add_ad', data, options);
    },
    // 校验否定关键词是否可以新建广告
    check_negative_keyword_add_ad:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/check_negative_keyword_add_ad', data, options);
    },
    // 校验广告系列是否可以新建广告系列
    check_campaign_add_campaign:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/check_campaign_add_campaign', data, options);
    },
    // 校验广告组是否可以新建广告组
    check_adgroup_add_adgroup:(data,options) => {
         options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/check_adgroup_add_adgroup', data, options);
    },


    // 2024.12.11 新增AD页面
    getAdList:(data,options) => {
        options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/get_ad_list', data, options);
    },
    getAdSearchList:(data,options) => {
        options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return post('/apple_promotion_manage/get_ad_search_list', data, options);
    },

    // 获取出价小数位数配置 获取小数点精度
    getPriceDecimalPlacesConfig:(data, options) => {
        options = Object.assign({},options||{},{
            headers:{
                "Accept-Language":'en',
            },
        });
        return get('/apple_promotion_manage/get_price_decimal_places_config', data, options);
    },
}
